import comp from "./CommentItem";
export default comp;
